import { useNavigate, useLocation } from 'react-router-dom';
import {
  UserOutlined,
  SoundOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  SettingOutlined,
  CreditCardOutlined,
  BellOutlined,
  AudioOutlined,
  AppstoreOutlined,
  HeartOutlined,
  ApiOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import './SideMenu.css';

const SideMenu = ({ collapsed, mobileOpen, onMobileClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = (key) => {
    navigate(key);
    if (onMobileClose) onMobileClose();
  };

  const menuItems = [
    { key: '/', label: 'Dashboard', icon: <DashboardOutlined /> },
    { key: '/users', label: 'Users', icon: <UserOutlined /> },
    { key: '/audios', label: 'Audios', icon: <SoundOutlined /> },
    { key: '/vocals', label: 'Vocals', icon: <PlayCircleOutlined /> },
    { key: '/music-styles', label: 'Music Styles', icon: <CustomerServiceOutlined /> },
    { key: '/genres', label: 'Genres', icon: <AudioOutlined /> },
    { key: '/explore', label: 'Explore', icon: <AppstoreOutlined /> },
    { key: '/notifications', label: 'Notifications', icon: <BellOutlined /> },
    { key: '/support', label: 'Support', icon: <HeartOutlined /> },
    { key: '/credit-products', label: 'Credit Products', icon: <CreditCardOutlined /> },
    { key: '/webhook-logs', label: 'Webhook Logs', icon: <ApiOutlined /> },
    { key: '/system', label: 'System', icon: <SettingOutlined /> },
  ];

  const isActive = (key) => {
    if (key === '/') return location.pathname === '/';
    return location.pathname.startsWith(key);
  };

  return (
    <aside className={`sidenav ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidenav-header">
        <a href="/" className="sidenav-brand">
          {!collapsed && <span className="sidenav-title">AudioArt AI</span>}
          {collapsed && <span className="sidenav-title-collapsed">AA</span>}
        </a>
      </div>

      <hr className="sidenav-divider" />

      <div className="sidenav-body">
        <ul className="sidenav-menu">
          {menuItems.map((item) => (
            <li key={item.key} className="sidenav-item">
              <a
                href={item.key}
                className={`sidenav-link ${isActive(item.key) ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigate(item.key);
                }}
              >
                <div className={`sidenav-icon ${isActive(item.key) ? 'active' : ''}`}>
                  {item.icon}
                </div>
                {!collapsed && <span className="sidenav-text">{item.label}</span>}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SideMenu;
